export const ketchScript = `// prevent everything from running more than once™
window.__ketchIntegrated__ = window.__ketchIntegrated__ || (function(window, document){
  // set default consent
  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  gtag('consent','default',{
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'personalization_storage': 'denied',
    'functionality_storage': 'granted',
    'security_storage': 'granted',
    'wait_for_update': 500
  });
  gtag("set", "ads_data_redaction", true);
  // Ketch smart tag
  !function(){window.semaphore=window.semaphore||[],window.ketch=function(){window.semaphore.push(arguments)};var e=new URLSearchParams(document.location.search),o=e.has("property")?e.get("property"):"website_smart_tag",n=document.createElement("script");n.type="text/javascript",n.src="https://global.ketchcdn.com/web/v3/config/ag1/".concat(o,"/boot.js"),n.defer=n.async=!0,document.getElementsByTagName("head")[0].appendChild(n)}();
  // Ketch GTM integration
  window.ketch("on", "consent", (consent) => {
    const ketchUpdatedConsent = consent.purposes;

    window.ketch("getConfig", (ketchConfig) => {
      const purposeConfig = ketchConfig.purposes;

      var canonicalPurposeGoogleKeyMap = {
        // Google GTM purposes
        ad_storage: ["ad_storage", "ad_user_data"],
        analytics_storage: ["analytics_storage", "analytics"],
        functionality_storage: ["functionality_storage", "security_storage"],
        personalization_storage: ["personalization_storage", "ad_personalization"],
        // Ketch default purposes
        behavioral_advertising: ["ad_storage", "ad_user_data"],
        analytics: ["analytics_storage"],
        essential_services: ["functionality_storage", "security_storage"],
        personalization: ["personalization_storage", "ad_personalization"],
      };

      let consentWithGooglePurposes = {};

      for (const purposeCode in ketchUpdatedConsent) {
        if (!purposeCode.includes(".")) {
          consentWithGooglePurposes[purposeCode] = ketchUpdatedConsent[purposeCode];
          for (const purpose of purposeConfig) {
            if (purpose.code === purposeCode) {
              const canonicalPurposes = purpose.canonicalPurposeCodes;
              if (canonicalPurposes) {
                for (const canonicalPurpose of canonicalPurposes) {
                  if (canonicalPurposeGoogleKeyMap[canonicalPurpose]) {
                    const gPurposes = canonicalPurposeGoogleKeyMap[canonicalPurpose];
                    for (const gp of gPurposes) {
                      if (consentWithGooglePurposes[gp]) {
                        consent[gp] = consentWithGooglePurposes[gp] || ketchUpdatedConsent[purposeCode];
                      } else {
                        consentWithGooglePurposes[gp] = ketchUpdatedConsent[purposeCode];
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      if (consent.purposes && window.gtmConsentListeners) {
        const consentUpdate = {
          purposes: consentWithGooglePurposes
        };
        window.gtmConsentListeners?.forEach((callback) => {
          callback(consentUpdate);
        });
      }

    });
  });
  return true;
})(window, document);`;
